import { useEffect } from 'react';
import { useLocation, useNavigate, useRoutes } from 'react-router-dom';
import StoreScreen from './pages/store';
import StoreV2 from './pages/storeV2';

const routes = [
  {
    path: '/',
    element: <StoreScreen />,
  },
  {
    path: '/t1',
    element: <StoreV2 />,
  },
];

const Router = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => window.scrollTo(0, 0));

  useEffect(() => {
    const handleBackButton = (event) => {
      event.preventDefault();
      navigate(location.pathname);
    };
    const {
      location: { pathname, search },
    } = window;
    const path = `${pathname}${search}`;
    window.history.pushState(null, '', path);
    window.addEventListener('popstate', handleBackButton);

    return () => {
      window.removeEventListener('popstate', handleBackButton);
    };
  }, [navigate, location.pathname]);

  return useRoutes(routes);
};

export default Router;
